import { viewActionTypes } from './view-action-types';
import { authorizedRequest } from '../../common/request';


 import {
    sliderItemsReceived,
    sliderItemsFailed, albumItemsReceived
} from '../../album-view/actions/album-item-actions';

export const requestImageData = (dispatch, elementId) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/cces/${elementId}?format=deep`)
		.then(element => dispatch(customCollectionElementReceived(element)))
		.catch(error => dispatch(customCollectionElementFailed(error)));

	return {
		type: viewActionTypes.ALBUM_IMAGE_REQUESTED,
		imageId: elementId
	};
};
export const requestAlbumItems = (dispatch,customCollectionId, cceId, offset = 0, reverse = false,max = 10)  => {
    return new Promise(function(resolve, reject) {
    	dispatch({
            type: viewActionTypes.ALBUM_ITEMS_SLIDER_REQUEST,
            collectionId: customCollectionId,
            isComplete: false,
            isReverse: reverse
        });
        // Function is expected to return a promise
        authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${customCollectionId}/cces?offset=${offset}&max=${max}&format=deep&cceId=${cceId}`)
            .then(data => {
                dispatch(albumItemsReceived(data, customCollectionId));
                dispatch(sliderItemsReceived(data, customCollectionId, reverse))
                resolve(data);
            })
            .catch(error => {
                dispatch(sliderItemsFailed(error))
				reject(error);
            });
    });
};


export const clearSelectedAlbumItems = () => {
	
		
	
	return {
		type: viewActionTypes.CLEAR_ALBUM_ITEM_SELECTION
		
	};
};
export const toggleRotate = () => {
	return {
		type:viewActionTypes.TOGGLE_ROTATE
	};
};
export const toggleVideoEditor = () => {
	return {
		type:viewActionTypes.TOGGLE_VIDEO_EDITOR
	};
};
export const toggleSlideShow = () => {
return {
		type: viewActionTypes.TOGGLE_SLIDE_SHOW
		
	};
};

export const toggleRightOpen = (status) => {
	return {
			type: viewActionTypes.TOGGLE_RIGHT_OPEN,
			status
			
		};
	};

export const clearAlbumItemsSlider = () => {
	
		
	
		return {
			type: viewActionTypes.CLEAR_ALBUM_ITEMS_SLIDER
			
		};
	};


	export const updateCurrentImageId = (imageId) => {
			
		return {
			type: viewActionTypes.ALBUM_IMAGE_CURRENT_UPDATED,
			imageId
			
		};
	};


	export const updateCurrentItemIdMediaPlayer = (itemId) => {
			
		return {
			type: viewActionTypes.UPDATE_CURRENT_ITEM_SHOWN_MEDIA_PLAYER,
			itemId
			
		};
	};

const customCollectionElementReceived = (element) => {
	return {
		type: viewActionTypes.ALBUM_IMAGE_RECEIVED,
		id: element.id,
        element: element
	};
};

const customCollectionElementFailed = error => {
	return {
		type: viewActionTypes.ALBUM_IMAGE_FAILED,
		error: error
	};
};



// WEBPACK FOOTER //
// ./src/view/actions/view-image-actions.js